<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1 class="text">{{this.$route.meta.title}}</h1>
            </div>

            <div class="section-body">
                <div class="row">
                    <div class="col-12 text-center mt-3" v-if="no_data === null">
                        <div class="half-circle-spinner">
                            <div class="circle circle-1"></div>
                            <div class="circle circle-2"></div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === false">
                        <div class="card bdr-15" >
                            <div class="card-header border-0 pb-4 tb-card">
                                <div class="table-sorting">
                                    <div class="table-search float-left">
                                        <vue-search
                                            :search="sorting"
                                            @searchdata="getAllEvents()">
                                        </vue-search>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive bdr-15">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>Action</th>
                                                <th>Agent</th>
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>Category</th>
                                                <th>Date Event</th>
                                                <th>Theme</th>
                                                <th>Package</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tr-ac" v-for="data in events.data" :key="data.id" @click.prevent="detailEvents(data)">
                                                <td v-on:click.stop="">
                                                    <b-dropdown id="dropdown-left" text="Settings" variant="primary" class="mt-2 mb-2">
                                                        <template #button-content>
                                                            Settings <i class="uil uil-angle-down"></i>
                                                        </template>

                                                        <b-dropdown-item href="#" v-if="data.status === 0" @click.prevent="detailEvents(data)">Edit Event</b-dropdown-item>
                                                        <b-dropdown-item href="#" v-if="data.status === 0" @click.prevent="alertStatusEvents(data)">Publish Event</b-dropdown-item>
                                                        <b-dropdown-item href="#" v-if="data.status === 1 && user.level === 1 || data.status === 1 && user.id === 23 && user.id === 88" @click.prevent="alertStatusEvents(data)">Un-Publish Event</b-dropdown-item>
                                                        <b-dropdown-item target="_blank" :href="data | eventLink">Visit Event</b-dropdown-item>
                                                        <b-dropdown-divider></b-dropdown-divider>
                                                        <b-dropdown-item v-if="data.type === 'PREMIUM'" href="#" @click.stop.prevent="copyBioLink(data.id)"><i class="uil uil-copy"></i> Copy Event Link</b-dropdown-item>
                                                        <b-dropdown-item href="#" @click.stop.prevent="copyAnalyticsLink(data.id)"><i class="uil uil-copy"></i> Copy Event Analytics Link</b-dropdown-item>
                                                    </b-dropdown>
                                                    <input type="hidden" :id="'biolink' + data.id" :value="$options.filters.eventLink(data)">
                                                    <input type="hidden" :id="'analyticslink' + data.id" :value="$options.filters.analyticsLink(data)">
                                                </td>
                                                <td>{{data.agent.name}}</td>
                                                <td>{{data.id}}</td>
                                                <td>{{data.title}}</td>
                                                <td>{{data.category ? data.category : '-'}}</td>
                                                <td>{{data.date_event | formatDate}}</td>
                                                <td>{{data.theme ? data.theme.name : '-'}}</td>
                                                <td>
                                                    <div class="premium-label" v-if="data.type === 'PREMIUM'">{{data.type}}</div>
                                                    <div class="standard-label" v-if="data.type === 'STANDARD'">{{data.type}}</div>
                                                </td>
                                                <td width="100px">
                                                    <label v-if="data.status === 1" class="badge badge-success"><i class="uil uil-check"></i> Publish</label>
                                                    <label v-if="data.status === 0" class="badge badge-info"><i class="uil uil-hourglass"></i> On Progress</label>
                                                </td>
                                            </tr>

                                        </tbody>

                                    </table>
                                    <p v-if="events.total === 0" class="text-center no-data">Events data not found</p>
                                </div>
                            </div>
                            <div class="card-footer">
                                <vue-pagination :pagination="events"
                                                :sorting="sorting"
                                                @paginate="getAllEvents()">
                                </vue-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="no_data === true && sorting.search === ''">
                        <div class="card bdr-15">
                            <div class="card-body card-nitem text-center">
                                <img class="mb-5" src="@/assets/img/no-data.svg" alt="">
                                <div class="nitem-desc">
                                    <h2>Events Data Still Empty</h2>
                                    <p>On this page you can create Events</p>
                                    <div class="tabel-action">
                                        <button type="submit" v-b-modal.modal-Events class="btn btn-new"><i class="uil uil-plus mr-2"></i> Add Events</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'
    import VuePagination from "@/components/Pagination.vue";
    import VueSearch from "@/components/Search.vue";
    import moment from 'moment'

    export default {
        name: "Events",
        components: {
            VuePagination,
            VueSearch,
        },
        data(){
            return {
                del_events:[],
                no_data: null,
            }
        },
        mounted(){
            this.title = this.$route.meta.title;
            this._getEvents()
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
            eventLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:8005/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug
            },
            analyticsLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug + '/analytics?code=' + value.token_analytics
            },
        },
        computed:{
            ...mapState('EventsControl', {
                events: state => state.all_events,
                sorting: state => state.sorting_all_event
            }),
            ...mapState('AuthControl', {
                user: state => state.user,
            }),
        },
        methods: {
            ...mapActions('EventsControl', ['getAllEvents','changeStatusEvent']),
            ...mapMutations('EventsControl', ['CLEAR_EVENTS']),

            copyBioLink (id) {
                let bioLinkToCopy = document.querySelector('#biolink' + id)
                bioLinkToCopy.setAttribute('type', 'text')
                bioLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                bioLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            copyAnalyticsLink (id) {
                let AnalyticsLinkToCopy = document.querySelector('#analyticslink' + id)
                AnalyticsLinkToCopy.setAttribute('type', 'text')
                AnalyticsLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                AnalyticsLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            _getEvents:function(){
                this.getAllEvents().then(() => {
                    if(this.events.total == 0){
                        this.no_data = true
                    }else{
                        this.no_data = false
                    }
                })
            },
            alertStatusEvents:function(data){
                var text = '';
                var sts = null;

                if(data.status === 0){
                    text = 'Are you sure you publish event ' + data.title + ' ?'
                    sts = 1
                }else if(data.status === 1){
                    text = 'Are you sure you un-publish event ' + data.title + ' ?'
                    sts = 0
                }

                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.changeStatusEvent({id:data.id,status:sts}).then(
                            this._getEvents(),
                            this.$toast.success('Successfully Change Status Event'),
                        )
                    }
                })
            },
            detailEvents:function(data){
                if(data.status === 1){
                    this.$toast.warning('You cannot edit this event because it is already published')
                }else if(data.status === 0){
                    this.$router.push({ name: 'details-event', params: { id:data.id,slug:data.slug } })
                }
            },
        },
        destroyed(){
            this.CLEAR_EVENTS()
        }
    };

</script>
